import axios from '@/axios';
import auth from '@/api/v1/auth';

const INDEX_URL = '/teachers';
const STUDENTS_LIST_URL = '/teachers/students';

export default {
  show(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response.data[auth.user.user_type]); });
  },
  update(user, succ, err) {
    axios.patch(INDEX_URL, { teacher: user })
      .then(() => { succ(); })
      .catch((error) => {
        err(error);
      });
  },
  list(succ) {
    axios.get(STUDENTS_LIST_URL)
      .then(response => succ(response));
  },
  studentExperiments(id, succ) {
    axios.get(`${STUDENTS_LIST_URL}/${id}`)
      .then(response => succ(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/teacher.js